import PrivacyPolicy from '../../documents/privacy-policy.pdf';
import TOS from '../../documents/TOS.pdf';


const PdfLinks = () => {
  return <>
    <a href={PrivacyPolicy} target='_blank' rel='noreferrer'>Privacy Policy</a>
    <a href={TOS} target='_blank' rel='noreferrer'>Terms of Service</a>
  </>
}

export default PdfLinks;